
import { defineComponent, nextTick } from 'vue';

import Info from '../Info/Info.vue';
import DesktopSocialGallery from "@/components/Social/Gallery/DesktopSocialGallery.vue";
import ProfileCommon from './Common.vue';
import PrzTabQuestions from '@/components/Social/Dialogs/Component.vue';
import { BlockSocial } from '@/models/Blocks/Itens/block-social';
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";
import przHistory from '@/models/prz-history';
import PrzSingleBlock from "@/components/Blocks/Block/Single.vue";
import {DeviceType} from "@/models/Blocks/Itens/Types/device-type";

export default defineComponent({
    extends: ProfileCommon,
    components: {
        PrzSingleBlock,
        Info,
        DesktopSocialGallery,
        PrzTabBlocks: () => import('@/components/Blocks/WithInfiniteScrollDesktop.vue'),
        PrzMention: () => import('@/components/Social/Mention.vue'),
        Breadcrumbs: () => import('@/components/ProductPage/Desktop-BlackRabbit/Breadcrumbs.vue'),
        Modal: () => import("@/components/Social/ContentBlocks/Modal.vue"),
        PrzTabQuestions
    },
    props: {
        campaigns: {
            type: Array,
            default: null
        },
    },
    data(){
        let mentionBlock: string|undefined;
        return {
            showMention: false,
            urlMention: '',
            mentionAlreadyShow: false,
            mentionBlock,
            fullyLoadedMention: false,
            preloadedPosts: null
        }
    },
    computed: {
        DeviceType() {
            return DeviceType
        }
    },
    watch:{
        tabSelected(){
            this.showMention = false;
        },
        selectedTab(){
            this.closeMention();
        },
        blocks(newValue){
            nextTick(() => {
                this.mentionPosition(newValue);
            });
        }
    },
    mounted(){
        this.findSelectTab(this.profile);
        if ( 'scrollRestoration' in history ) {
            history.scrollRestoration = 'manual';
        }
        if(!this.profile.tabs || this.profile.tabs.length == 0){
            nextTick(() => {
                this.mentionPosition(undefined);
            });
        }
    },
    methods:{
        mentionPosition(newValue: Array<TemplateStruct>|undefined){
            if(this.mention && !this.mentionAlreadyShow){
                this.urlMention = this.formatUrlMention(this.mention);
                let fristKey    = newValue && newValue.length > 0 ? newValue[0]?.key ?? null : null;
                if(fristKey){
                    this.mentionBlock = `before_${fristKey}`;
                    this.mentionAlreadyShow = true;
                    this.showMention  = true;
                }
            }
        },
        async openMention(social: any){
            if(social instanceof BlockSocial){
                let url:string|null = social.extraInfo ?? null;
                this.showMention = false;
                if(url){
                    let fUrl = this.formatUrlMention(url);
                    if(fUrl == this.urlMention){
                        this.scrollIntoDetails();
                    }else{
                        this.urlMention   = fUrl;
                        this.mentionBlock = `before_${social.blockKey}`;
                        url = przHistory.formatUrl(url);
                        if(!this.clubMode) {
                            history.replaceState({},'', przHistory.formatUrl(url));
                        }
                    }
                    this.showMention  = true;
                }
            }   
        },
        formatUrlMention(url: string){
            return url + (url.includes('?') ? '&' : '?') + ('exclude=saveCommentUrl,kStrings,isDesktop,isAppStore');
        },
        closeMention(){
            const isOpen      = this.showMention;
            this.showMention  = false;
            this.fullyLoadedMention = false;
            this.preloadedPosts = null;
            this.urlMention   = '';
            this.mentionBlock = undefined;
            if(isOpen && this.profile?.url){
                history.replaceState({},'', przHistory.formatUrl(this.profile.url));
            }
        },
        backMention(){
            history.back();
        },
        async scrollIntoDetails(){
            await nextTick();
            setTimeout(() => {
                let elem = this.$el.querySelector('.prz-social-content-details');
                if(elem){
                    elem.scrollIntoView({ behavior: "smooth", block: "end" });
                }
                this.fullyLoadedMention = true;
            },150);
        },
        updatePreloadedPosts(preloadedPosts = null) {
            if (preloadedPosts) {
                this.preloadedPosts = preloadedPosts;
            }
        }
    }
});
